export const state = {
  callHistoryPanelVisible: false,
  searchResultsPanelVisible: false,
};

export const mutations = {
  setCallHistoryPanelVisibility(state, visible) {
    state.callHistoryPanelVisible = visible;
  },

  setSearchResultsPanelVisibility(state, visible) {
    state.searchResultsPanelVisible = visible;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
